// extracted by mini-css-extract-plugin
module.exports = {"column":"_2xsZENphWysaPAKVE76AIb"};